import { ExpandMoreRounded } from "@mui/icons-material";
import {
  Accordion as MuiAccordion,
  AccordionDetails,
  AccordionSummary,
  Divider,
} from "@mui/material";
import * as React from "react";
import { Fragment } from "react";

const Accordion = (props) => {
  const { items, ...other } = props;
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div>
      {items.map((item, i) => (
        <Fragment key={i}>
          <MuiAccordion
            expanded={expanded === `panelId:${i}`}
            onChange={handleChange(`panelId:${i}`)}
            sx={{
              backgroundColor: "transparent",
              boxShadow: "none",
              m: "0px",
              "&.MuiPaper-root.MuiAccordion-root:before": {
                display: "none",
              },
            }}
            {...other}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreRounded />}
              aria-controls="panel1bh-content"
              id="panel1bh-header"
              sx={{
                flexDirection: "row-reverse",
                px: "8px",
                "&.Mui-focusVisible": { backgroundColor: "transparent" },
                "& .MuiAccordionSummary-content": { m: 0 },
                "& .MuiAccordionSummary-content.Mui-expanded": { m: 0 },
                "& .MuiAccordionSummary-expandIconWrapper .MuiSvgIcon-root": {
                  fontSize: 18,
                  m: "2px",
                },
              }}
            >
              {item.header}
            </AccordionSummary>
            <AccordionDetails sx={{ pt: 0, pb: "2px", px: "8px" }}>{item.body}</AccordionDetails>
          </MuiAccordion>
          <Divider />
        </Fragment>
      ))}
    </div>
  );
};

export default Accordion;
